module.exports = __webpack_public_path__ + "img/inter24.d4f5676b.jpg";